import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-code",
  templateUrl: "./code.component.html",
  styleUrls: ["./code.component.scss"],
})
export class CodeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
